import {InjectionToken} from '@angular/core'
import {TAudience} from '@vambie/vambie-bankid-gw'

export const ACCESS_TOKEN_KEY = 'vambie-at'

export interface IEnvironment {
  production: boolean,
  apiUrl: string // 'https://api-vambie-trade-be-test.vambie.net/api',
  bankIdGatewayUrl: string // 'https://api-ff-bankid-gw-test.vambie.net/service',
  // Where to find the Swish service
  swishUrl: string
  audience: TAudience
}

export const ENVIRONMENT = new InjectionToken<IEnvironment>('environment')
export const LOCAL_STORAGE = new InjectionToken<Storage>('localStorage')
